<script setup>
import {
  NNotificationProvider,
  NMessageProvider,
  NDialogProvider,
  NConfigProvider,
  useLoadingBar
} from 'naive-ui'

import { useRouter } from 'vue-router'

const router = useRouter()
const loadingBar = useLoadingBar()

router.beforeEach(() => loadingBar?.start())
router.afterEach(() => loadingBar?.finish())
</script>

<template>
  <n-config-provider>
    <n-notification-provider>
      <n-message-provider>
        <n-dialog-provider>
          <div class="app-provider">
            <slot></slot>
          </div>
        </n-dialog-provider>
      </n-message-provider>
    </n-notification-provider>
  </n-config-provider>
</template>

<style lang="scss" scoped>
div.app-provider {
  min-height: 100vh;
}
</style>
